export default __webpack_public_path__ + "static/media/Mihai.924cc92a.png";